import { useQrCodeStore } from '@/hooks/useQrCode';
import { QRCodeSVG } from 'qrcode.react';
import { useRef } from 'react';

interface QrCodeGeneratorProps {
  slug: string;
  size?: number;
  className?: string;
  svgRef?: React.RefObject<SVGSVGElement>;
  qrColor: string | null;
}

export const QrCodeGenerator = ({
  slug,
  size,
  className = '',
  svgRef: externalSvgRef,
  qrColor,
}: QrCodeGeneratorProps) => {
  const internalSvgRef = useRef<SVGSVGElement>(null);

  // Utiliser le ref externe s'il est fourni, sinon utiliser le ref interne
  const svgRef = externalSvgRef || internalSvgRef;

  // Utiliser directement le store pour obtenir la configuration la plus récente
  const qrCodeConfig = useQrCodeStore(state =>
    state.generateQrCodeConfig(slug, qrColor),
  );

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <QRCodeSVG
        ref={svgRef}
        value={qrCodeConfig.value}
        size={size || qrCodeConfig.size}
        bgColor={qrCodeConfig.bgColor}
        fgColor={qrCodeConfig.fgColor}
        level={qrCodeConfig.level}
        imageSettings={qrCodeConfig.imageSettings}
      />
    </div>
  );
};
